var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.disabled)?_c('a',_vm._g({class:'style_'+_vm._style+' size_'+_vm._size,attrs:{"tabindex":"0","href":_vm.href}},_vm.$listeners),[_vm._t("default")],2):_c('button',_vm._g({class:'style_'+_vm._style+' size_'+_vm._size,attrs:{"tabindex":"0","disabled":""}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }